export function centsToDollars(cents?: number, decimalPlaces: number = 0) {
  if (cents === undefined) return "";
  const sign = Math.sign(cents) < 0 ? "-" : "";
  return `${sign}$${Math.abs(cents / 100).toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })}`;
}
